import { z } from 'zod'
import { RewardCategory } from '~library/enums'

export const benefitAndVoucherManagementGetExclusiveBenefitListSchema =
  z.object({
    /** 分類選項 */
    classType: z.nativeEnum(RewardCategory),
    /** 分類次選項 */
    classSecondType: z.string(),
    /** 數量 */
    quantity: z.number(),
    /** 最快到期日 */
    fastestExpiryTime: z.string(),
    /** fileId */
    fileId: z.string()
  })

export interface BenefitAndVoucherManagementGetExclusiveBenefitList
  extends z.infer<
    typeof benefitAndVoucherManagementGetExclusiveBenefitListSchema
  > {}
